import { DataType } from '@bechtel/sr-types';
import { ButtonCellRenderer } from './button';
import { ComplexFilterCellRenderer } from './complex-filter';
import { DatetimeCellRenderer } from './datetime';
import { LinkCellRenderer } from './link';
import { PickListCellRenderer } from './pick-list';
import { SelectCellRenderer } from './select';
import { StatusBarLeft, StatusBarRight } from './status-bars';

export const cellRendererComponents = (navigationURL, onRowEdited, rowHeight) => {
  return {
    linkComponent: (props) => (
      <PickListCellRenderer {...props} onRowEdited={onRowEdited} rowHeight={rowHeight}>
        <LinkCellRenderer {...props} navigationURL={navigationURL} />
      </PickListCellRenderer>
    ),
    selectComponent: (props) => <SelectCellRenderer {...props} onRowEdited={onRowEdited} rowHeight={rowHeight} />,
    datetimeComponent: (props) => <DatetimeCellRenderer {...props} onRowEdited={onRowEdited} rowHeight={rowHeight} />,
    buttonComponent: (props) => <ButtonCellRenderer {...props} rowHeight={rowHeight} />,
    customStatusBarRight: StatusBarRight,
    customStatusBarLeft: StatusBarLeft,
    pickListComponent: (props) => <PickListCellRenderer {...props} onRowEdited={onRowEdited} rowHeight={rowHeight} />,
    complexFilterComponent: (props) => (
      <ComplexFilterCellRenderer {...props} onRowEdited={onRowEdited} rowHeight={rowHeight}></ComplexFilterCellRenderer>
    ),
  };
};
export const getCellRenderers = (
  index: number,
  dataType?: string | null,
  pickListName?: string | null,
  hasNavigation?: boolean
) => {
  if (index === 1 && hasNavigation) return 'linkComponent';
  else if (pickListName) return `pickListComponent`;
  else if (dataType === DataType.BOOLEAN) return 'agCheckboxCellRenderer';
  else if (dataType === DataType.DATETIME || dataType === DataType.DATE) return `datetimeComponent`;
  else return null;
};
